import { createContext, useContext } from "react";

export interface FormFieldContextValue {
  id: string;
  ariaDescribedBy: string | undefined;
  ariaInvalid: boolean;
  required: boolean;
  error: string | undefined;
}

export const FormFieldContext = createContext<FormFieldContextValue | null>(
  null,
);

export function useFormFieldContext(): FormFieldContextValue | null {
  return useContext(FormFieldContext);
}
